import React from 'react';

export default function PlotHeader({ metadata, plotId }) {
  if (!metadata) return null;

  const {
    name = `Plot ${plotId}`,
    propertyName,
    cropType,
    areaHectares,
    crops
  } = metadata;

  const varietal = crops?.[0]?.varietal_cultivar || '';

  return (
    <div style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '16px' }}>
      <h2 style={{ margin: '0 0 6px 0', color: '#0f172a' }}>{name}</h2>
      <p style={{ margin: 0, color: '#475569', fontSize: '14px' }}>
        <strong>Farm:</strong> {propertyName} |{' '}
        <strong>Crop:</strong> {cropType}{varietal ? ` (${varietal})` : ''} |{' '}
        <strong>Area:</strong> {areaHectares} ha
      </p>
    </div>
  );
}
